/* Book product page: the gallery (cover placement, swipe, thumbnails, arrows, keys, lightbox), the quantity offer, Add
 * to cart, Look inside, the bundle band, quotes and in-page links. Contract: sections/book.liquid (its header comment).
 * Rules: assets/book-pdp-model.js (BookPdpModel); quotes: assets/wall-art-model.js (WallArtModel.curlText).
 * No jQuery. No <form>: DealEasy rewrites product-form quantities store-wide, so Add to cart posts to /cart/add.js. */
(function () {
  'use strict';
  var root = document.querySelector('[data-bk-pdp]');
  var M = window.BookPdpModel;
  if (!root || !M) return;
  var W = window.WallArtModel;

  function json(sel) { try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return null; } }
  function all(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function reducedMotion() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  var product = json('[data-bk-product]') || { variants: [] }, cfg = json('[data-bk-config]') || {};
  var api = window.bookPdp = window.bookPdp || {};
  if (!api.go) api.go = function (url) { window.location.href = url; };

  // The full-bleed root is sized from the viewport; a classic scrollbar makes 100vw wider than the page.
  function scrollbar() { root.style.setProperty('--bk-sb', (window.innerWidth - document.documentElement.clientWidth) + 'px'); }
  scrollbar();
  window.addEventListener('resize', scrollbar);

  // Typographer's quotes in the description and the FAQ answers (wall art's pass, text node by text node; the section
  // curls the plain-text fields server-side).
  function curlQuotes(container) {
    if (!W || !W.curlText || !container || container.hasAttribute('data-bk-curled')) return;
    container.setAttribute('data-bk-curled', '');
    var SKIP = 'code, pre, input, textarea, script, style', BLOCK = 'p, li, dd, dt, td, th, blockquote, h1, h2, h3, h4, h5, h6, figcaption, summary, div';
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.parentElement && n.parentElement.closest(SKIP) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; }
    });
    var state = W.quoteState(), block = null, node;
    while ((node = walker.nextNode())) {
      var b = node.parentElement.closest(BLOCK) || container;
      if (b !== block) { block = b; state = W.quoteState(); }
      var t = node.nodeValue;
      if (!/["']/.test(t)) { if (t) state.prev = t.charAt(t.length - 1); continue; }
      var curled = W.curlText(t, state);
      if (curled !== t) node.nodeValue = curled;
    }
  }
  curlQuotes(root.querySelector('.bk-about__body'));
  all('.bk-faq__item > :not(summary)').forEach(curlQuotes);

  /* ---------- Gallery ---------- */
  var gallery = root.querySelector('[data-bk-gallery]');
  var track = gallery && gallery.querySelector('[data-bk-track]');
  var slides = track ? all('[data-bk-slide]', track) : [];
  var thumbs = gallery ? all('[data-bk-thumb]', gallery) : [];
  var segs = gallery ? all('[data-bk-seg]', gallery) : [];
  var statusEl = gallery && gallery.querySelector('[data-bk-status]');
  var idx = 0, slideHooks = [];
  var phoneMQ = window.matchMedia ? window.matchMedia('(max-width: 599px)') : { matches: false };

  // The thumbnail strip: one row of eight that slides. Its arrows show only when there is more that way; the current
  // thumbnail is scrolled into view (the strip only, never the page).
  var strip = gallery && gallery.querySelector('[data-bk-thumbs]');
  var stripPrev = gallery && gallery.querySelector('[data-bk-thumbs-prev]'), stripNext = gallery && gallery.querySelector('[data-bk-thumbs-next]');
  function stripScroll(left) {
    try { strip.scrollTo({ left: left, behavior: reducedMotion() ? 'auto' : 'smooth' }); } catch (e) { strip.scrollLeft = left; }
  }
  function thumbInView(t) {
    if (!strip || strip.scrollWidth <= strip.clientWidth + 1) return;
    var a = t.offsetLeft, b = a + t.offsetWidth, l = strip.scrollLeft, w = strip.clientWidth;
    if (a < l) stripScroll(a);
    else if (b > l + w) stripScroll(b - w);
  }
  function stripArrows() {
    if (!strip) return;
    var l = strip.scrollLeft, max = strip.scrollWidth - strip.clientWidth;
    var row = strip.parentNode;
    row.classList.toggle('can-l', l > 1);
    row.classList.toggle('can-r', l < max - 1);
    if (stripPrev) stripPrev.hidden = !(l > 1);
    if (stripNext) stripNext.hidden = !(l < max - 1);
  }
  if (strip) {
    var page = function (d) { stripScroll(strip.scrollLeft + d * Math.max(1, strip.clientWidth - (thumbs[0] ? thumbs[0].offsetWidth : 0))); };
    if (stripPrev) stripPrev.addEventListener('click', function () { page(-1); });
    if (stripNext) stripNext.addEventListener('click', function () { page(1); });
    strip.addEventListener('scroll', stripArrows, { passive: true });
    window.addEventListener('resize', stripArrows);
    stripArrows();
  }

  // model-viewer 4.3.1, imported once, when a 3D view is wanted: the version print-render renders the posters with, and
  // the first with tone-mapping="neutral" (true product colour; 3.1.1's only curve, ACES, greyed the darks and faded
  // the cover against its own art). Not imported when another script (pmslider) already brought one.
  var mvStarted = false;
  function loadModelViewer() {
    if (mvStarted) return;
    mvStarted = true;
    if (window.customElements && !customElements.get('model-viewer') && !window.pmsliderMVI) {
      var sc = document.createElement('script');
      sc.type = 'module';
      sc.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.3.1/model-viewer.min.js';
      document.head.appendChild(sc);
    }
  }

  function setCurrent(i) {
    if (i === idx && statusEl && statusEl.textContent) return;
    idx = i;
    thumbs.forEach(function (t, j) { t.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    if (thumbs[i]) thumbInView(thumbs[i]);
    segs.forEach(function (s, j) { if (j === i) s.setAttribute('data-on', ''); else s.removeAttribute('data-on'); });
    if (statusEl) statusEl.textContent = (slides[i] && slides[i].hasAttribute('data-bk-model-slide') ? 'The book in 3D, ' : 'Photo ') + (i + 1) + ' of ' + slides.length;
    slideHooks.forEach(function (f) { f(i); });
  }
  function go(i, instant) {
    if (!track || !slides.length) return;
    var n = slides.length;
    i = ((i % n) + n) % n;
    var left = i * slides[0].offsetWidth;
    try { track.scrollTo({ left: left, behavior: instant || reducedMotion() ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft = left; }
    setCurrent(i);
  }
  if (track && slides.length) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = slides[0].offsetWidth || 1, i = Math.round(track.scrollLeft / w);
        if (i !== idx && i >= 0 && i < slides.length) setCurrent(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-bk-thumb'), 10)); }); });
    var prev = gallery.querySelector('[data-bk-prev]'), next = gallery.querySelector('[data-bk-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    // Left and right arrow keys anywhere in the gallery (the track is focusable).
    gallery.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.target.closest && e.target.closest('model-viewer')) return;   // the arrow keys turn the model
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
    });
    // A resize keeps the current slide in place (scroll positions are in pixels).
    window.addEventListener('resize', function () { go(idx, true); });
    setCurrent(0);
  }

  // Loading ahead. The slides past the first are loading="lazy", and a lazy image in a sideways scroller only starts
  // once it slides into view, so each new photo arrived blank. Instead: once the page has loaded (when the browser is
  // idle), the next two slides and the last (the left arrow wraps to it); after every move, the slides either side and
  // the one after next; a thumbnail or an arrow as the pointer reaches it. Never all at once (13 photos are ~2.5 MB).
  (function () {
    if (!track || slides.length < 2) return;
    var n = slides.length;
    function warm(i) {
      var s = slides[((i % n) + n) % n];
      if (!s || s.hasAttribute('data-bk-warm')) return;
      s.setAttribute('data-bk-warm', '');
      all('img[loading="lazy"]', s).forEach(function (img) { img.loading = 'eager'; });
    }
    function around(i) { warm(i + 1); warm(i - 1); warm(i + 2); }
    slideHooks.push(function (i) { if (document.readyState === 'complete') around(i); });
    function start() { around(idx); }
    function idle() { if (window.requestIdleCallback) requestIdleCallback(start, { timeout: 2000 }); else setTimeout(start, 200); }
    if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
    thumbs.forEach(function (t) {
      var j = parseInt(t.getAttribute('data-bk-thumb'), 10);
      ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) { t.addEventListener(ev, function () { warm(j); }, { passive: true }); });
    });
    ['[data-bk-prev]', '[data-bk-next]'].forEach(function (sel, k) {
      var b = gallery.querySelector(sel);
      if (b) b.addEventListener('pointerenter', function () { warm(idx + (k ? 1 : -1)); }, { passive: true });
    });
  })();

  // The 3D slide. model-viewer is imported only once the shopper heads for the
  // slide: its thumbnail hovered, focused or touched, an arrow beside it, or the slide scrolling into view. The poster
  // fades once the model has loaded over it. On touch screens the model turns only after "Turn it", so a swipe across
  // it still moves the gallery; leaving the slide turns that off again.
  (function () {
    var slide = track && track.querySelector('[data-bk-model-slide]');
    if (!slide) return;
    var mv = slide.querySelector('[data-bk-model]'), turn = slide.querySelector('[data-bk-model-turn]');
    var at = slides.indexOf(slide), load = loadModelViewer;
    if (mv) mv.addEventListener('load', function () { slide.classList.add('is-loaded'); });
    function setTurning(on) {
      slide.classList.toggle('is-turning', on);
      if (turn) turn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    if (turn) turn.addEventListener('click', function () { load(); setTurning(!slide.classList.contains('is-turning')); });
    var thumb = gallery.querySelector('[data-bk-model-thumb]');
    if (thumb) ['pointerenter', 'focus', 'touchstart'].forEach(function (t) { thumb.addEventListener(t, load, { passive: true }); });
    ['[data-bk-prev]', '[data-bk-next]'].forEach(function (sel, k) {
      var b = gallery.querySelector(sel);
      if (b) b.addEventListener('pointerenter', function () { if (idx + (k ? 1 : -1) === at) load(); });
    });
    slideHooks.push(function (i) { if (i === at) load(); else setTurning(false); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { load(); io.disconnect(); } }, { root: track, threshold: 0.1 });
      io.observe(slide);
    }
  })();

  // Sticky gallery (wall art's rule): from 900px it sticks while the buy column scrolls, only when it fits the viewport.
  (function () {
    if (!gallery) return;
    var GAP = 24;
    function check() {
      root.style.setProperty('--bk-sticky-top', GAP + 'px');
      var twoCols = window.matchMedia ? window.matchMedia('(min-width: 900px)').matches : window.innerWidth >= 900;
      gallery.classList.toggle('is-sticky', twoCols && gallery.offsetHeight > 0 && gallery.offsetHeight + GAP <= window.innerHeight);
    }
    check();
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
    if ('ResizeObserver' in window) new ResizeObserver(check).observe(gallery);
  })();

  // The cover render, set on the page and sized by the BOOK (Gallery.dc.html): a 400px rendition is drawn to a canvas
  // and the book's box found (pixels darker than luminance 200; the shadow's lightest greys never cross it), with the
  // box of everything visible (darker than 247: the shadow too), and the paper's white (its corners). The book then fills the target box (92% of the frame's
  // width, or its height) centred on it, shrunk if the shadow would run past the bleed or the spill; the thumbnail the
  // same in its own box. A stored fit (pdp.cover_fit, see the section) places it before first paint instead. Cached per image URL in sessionStorage. Until measured (or 600 ms, then Iron Mike's box, which
  // is also the fallback) the cover is held invisible, then fades in, so it never jumps. A first image whose dark box
  // fills it edge to edge (a flat cover photo, no white margin) is shown as a card like the other slides.
  (function () {
    var cover = root.querySelector('[data-bk-cover]');
    if (!cover || !gallery) return;
    var url = cover.getAttribute('data-bk-measure'), key = 'bk-box2:' + url;
    var ar = (+cover.getAttribute('width') || 3) / (+cover.getAttribute('height') || 2);
    // The frame: 6:5, square for a portrait book (.bk-gallery--tall, set on the server from the page size; never changed
    // here, so the page does not move).
    var done = false, measured = null;
    function frame() { return gallery.classList.contains('bk-gallery--tall') ? 1 : 6 / 5; }
    function targets() {
      // On a phone there is no bleed (the stage is the screen's width); the shadow's faintest few percent may run off
      // its edge, where it is lighter than the eye can tell from the ground.
      var phone = phoneMQ.matches, w = track ? track.clientWidth : 0, bleed = phone ? 0 : 96, spill = phone ? 28 : 56;
      var fw = Math.max(1, w - 2 * bleed), fh = fw / frame();
      return {
        target: phone ? { x0: 0.05, y0: 0.02, x1: 0.95, y1: 0.95 } : { x0: 0.04, y0: 0.02, x1: 0.96, y1: 0.92 },
        outer: { x0: -(bleed || 0.04 * fw) / fw, y0: -0.02, x1: 1 + (bleed || 0.04 * fw) / fw, y1: 1 + spill * 0.75 / fh }
      };
    }
    function apply(box) {
      var book = (box && box.book) || cfg.box, ink = box && box.ink;
      var card = !!(box && box.book && box.book.x0 < 0.02 && box.book.x1 > 0.98 && box.book.y0 < 0.02 && box.book.y1 > 0.98);
      var slide = cover.closest('[data-bk-slide]');
      if (slide) slide.classList.toggle('bk-slide--card', card);
      gallery.classList.toggle('bk-gal--card', card);
      // A render whose paper is a level or two under white is lifted to white (brightness, at most 3%), so the
      // multiplied ground matches the page exactly.
      var g = box && box.ground, lift = g ? Math.min(1.03, 255 / Math.min(g[0], g[1], g[2])) : 1;
      gallery.style.setProperty('--bk-lift', card ? '1' : lift.toFixed(4));
      if (!card && book) {
        var t = targets(), p = M.place(book, ar, frame(), t.target, ink, t.outer);
        var th = M.place(book, ar, 1, { x0: 0.08, y0: 0.1, x1: 0.92, y1: 0.84 });
        gallery.style.setProperty('--bk-cl', p.left + '%');
        gallery.style.setProperty('--bk-ct', p.top + '%');
        gallery.style.setProperty('--bk-cw', p.width + '%');
        gallery.style.setProperty('--bk-tl', th.left + '%');
        gallery.style.setProperty('--bk-tt', th.top + '%');
        gallery.style.setProperty('--bk-tw', th.width + '%');
      }
    }
    function show(box) {
      if (box) measured = box;
      if (done && !box) return;
      apply(measured);
      if (!done) { done = true; cover.classList.add('is-placed'); }
    }
    // The stored fit (pdp.cover_fit): the section has already placed the cover with it and shown it, so this only
    // re-places it for the exact width, from the same measure, with no image to fetch.
    var stored = null;
    try { stored = JSON.parse(cover.getAttribute('data-bk-fit') || 'null'); } catch (e) { stored = null; }
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { cached = null; }
    if (stored && stored.book) { done = true; measured = stored; apply(stored); }
    else if (cached && cached.book) { show(cached); }
    else {
      var timer = setTimeout(function () { show(null); }, 600);
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight, c = document.createElement('canvas');
          c.width = w; c.height = h;
          var ctx = c.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0);
          var data = ctx.getImageData(0, 0, w, h).data;
          var box = { book: M.measure(data, w, h, 200, 2), ink: M.measure(data, w, h, 247, 2), ground: M.ground(data, w, h) };
          if (!box.book) return;
          try { sessionStorage.setItem(key, JSON.stringify(box)); } catch (e) { /* storage off */ }
          clearTimeout(timer);
          show(box);
        } catch (e) { /* a tainted canvas: the default box stands */ }
      };
      img.src = url;
    }
    if (phoneMQ.addEventListener) phoneMQ.addEventListener('change', function () { apply(measured); });
    window.addEventListener('resize', function () { if (done) apply(measured); });
  })();

  /* ---------- Dialogs: lightbox and Look inside ---------- */
  function openDialog(dlg, opener) {
    if (!dlg || dlg.open) return;
    dlg._opener = opener || document.activeElement;
    // The page stops scrolling behind it; a classic scrollbar's width is kept as padding so nothing shifts.
    var sb = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = 'hidden';
    if (sb > 0) document.documentElement.style.paddingRight = sb + 'px';
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function onClosed(dlg) {
    dlg.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      document.documentElement.style.paddingRight = '';
      var o = dlg._opener;
      if (o && o.isConnected) { try { o.focus({ preventScroll: true }); } catch (e) { o.focus(); } }
    });
    // A click on the dark ground (the dialog itself, not its contents) closes it.
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  var lb = root.querySelector('[data-bk-lightbox]');
  var lbItems = slides.map(function (s) { var b = s.querySelector('[data-bk-open]'); return b ? { full: b.getAttribute('data-bk-full'), alt: (b.querySelector('img') || {}).alt || '' } : null; });
  var lbList = [];                 // slide indexes with a photo (videos are left out)
  lbItems.forEach(function (it, i) { if (it) lbList.push(i); });
  var lbAt = 0;
  function lbShow(k) {
    var n = lbList.length;
    lbAt = ((k % n) + n) % n;
    var it = lbItems[lbList[lbAt]], img = lb.querySelector('[data-bk-lb-img]');
    img.src = it.full; img.alt = it.alt;
    lb.querySelector('[data-bk-lb-count]').textContent = (lbAt + 1) + ' of ' + n;
    all('[data-bk-lb-prev], [data-bk-lb-next]', lb).forEach(function (b) { b.hidden = n < 2; });
  }
  if (lb && lbList.length) {
    slides.forEach(function (s, i) {
      var b = s.querySelector('[data-bk-open]');
      if (b) b.addEventListener('click', function () { lbShow(lbList.indexOf(i)); openDialog(lb, b); lb.querySelector('[data-bk-lb-close]').focus(); });
    });
    lb.querySelector('[data-bk-lb-close]').addEventListener('click', function () { lb.close(); });
    lb.querySelector('[data-bk-lb-prev]').addEventListener('click', function () { lbShow(lbAt - 1); });
    lb.querySelector('[data-bk-lb-next]').addEventListener('click', function () { lbShow(lbAt + 1); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); lbShow(lbAt - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); lbShow(lbAt + 1); }
    });
    // The gallery follows the lightbox, so closing it leaves the shopper on the photo they were looking at.
    // Focus goes back to that photo's own button (not the one that opened it, which may now be off to the side).
    lb.addEventListener('close', function () {
      var i = lbList[lbAt], b = slides[i] && slides[i].querySelector('[data-bk-open]');
      if (i !== idx) go(i, true);
      if (b) lb._opener = b;
    });
    onClosed(lb);
  }

  var look = root.querySelector('[data-bk-look]'), lookOpen = root.querySelector('[data-bk-look-open]');
  if (look && lookOpen) {
    onClosed(look);
    lookOpen.addEventListener('click', function () {
      var body = look.querySelector('[data-bk-look-body]'), src = look.querySelector('template[data-bk-look-src]');
      if (body && src && !body.firstChild) body.appendChild(src.content.cloneNode(true));   // the embed loads on first open
      openDialog(look, lookOpen);
      look.querySelector('[data-bk-look-close]').focus();
    });
    look.querySelector('[data-bk-look-close]').addEventListener('click', function () { look.close(); });
  }

  /* ---------- The variant, the quantity offer, Add to cart ---------- */
  var variantId = root.getAttribute('data-bk-variant') || String(cfg.variantId || '');
  var variant = null;
  (product.variants || []).forEach(function (v) { if (String(v.id) === String(variantId)) variant = v; });
  if (!variant) variant = (product.variants || [])[0] || null;
  var price = variant ? variant.price : 0;
  var pct = +cfg.pct || 5, min = +cfg.min || 4;
  var pediment = root.classList.contains('bk-own-pediment');
  var tiers = root.querySelector('[data-bk-tiers]');
  // One stepper beside Add to cart. With the offer, each card keeps its last count: stepping across 4 moves the
  // selection to the other card, and picking a card brings back its count.
  // A page with the offer but no cards (cfg.offerAuto: a product lander that names the offer in its copy) starts at one
  // copy, and its totals take the offer's price from `min` copies, as the cart will.
  var auto = !tiers && !!cfg.offerAuto;
  var state = { tier: tiers ? 'bulk' : auto ? 'single' : 'plain', single: 1, bulk: min, plain: 1 };
  var adding = false;
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  function qty() { return state[state.tier]; }
  function render() {
    // The price row follows the variant to add (the ownership swap can change it; normally the prices match).
    if (variant) {
      var sale = variant.compare_at_price && variant.compare_at_price > price;
      all('[data-bk-price]').forEach(function (el) { setText(el, M.money(price)); });
      all('[data-bk-compare]').forEach(function (el) { el.hidden = !sale; });
      all('[data-bk-compare-price]').forEach(function (el) { setText(el, sale ? M.money(variant.compare_at_price) : ''); });
    }
    if (tiers) {
      all('[data-bk-tier]', tiers).forEach(function (card) {
        var key = card.getAttribute('data-bk-tier'), on = key === state.tier, q = state[key], t = M.tier(price, q, pct, min);
        var radio = card.querySelector('input[type="radio"]');
        if (radio && radio.checked !== on) radio.checked = on;
        if (on) card.setAttribute('data-on', ''); else card.removeAttribute('data-on');
        setText(card.querySelector('[data-bk-tier-price]'), M.money(t.total));
        setText(card.querySelector('[data-bk-tier-was]'), M.money(t.line));
        setText(card.querySelector('[data-bk-tier-save]'), 'You save ' + M.money(t.save));
        if (key === 'bulk') {
          // The GemPage's DealEasy rule: free shipping is named for Pediment-ownership shoppers from a $100 total.
          setText(card.querySelector('[data-bk-bulk-sub]'), 'An extra ' + pct + '% off' + (pediment && t.total >= 10000 ? ', and shipping is free' : ''));
        }
      });
    }
    all('[data-bk-stepper]').forEach(function (st) {
      setText(st.querySelector('[data-bk-qty]'), String(qty()));
      all('[data-bk-step]', st).forEach(function (b) {
        b.disabled = +b.getAttribute('data-bk-step') < 0 ? qty() <= 1 : qty() >= 99;
      });
    });
    var total = M.tier(price, qty(), state.tier === 'bulk' ? pct : 0, min).total;
    all('[data-bk-total]').forEach(function (el) { setText(el, M.money(total)); });
    var ok = !!(variant && variant.available);
    all('[data-bk-add]').forEach(function (b) { b.disabled = !ok || adding; b.setAttribute('aria-busy', adding ? 'true' : 'false'); });
    if (!ok) all('[data-bk-error]').forEach(function (el) { setText(el, 'Sold out for now.'); });
  }

  root.addEventListener('change', function (e) {
    var r = e.target;
    if (r && r.name === 'bk-copies' && r.checked) { state.tier = r.value; render(); }
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bk-step]');
    if (b && root.contains(b) && !b.disabled) {
      var q = Math.min(99, Math.max(1, qty() + (+b.getAttribute('data-bk-step'))));
      if (tiers || auto) state.tier = q >= min ? 'bulk' : 'single';
      state[state.tier] = q;
      render();
      return;
    }
    var add = e.target.closest && e.target.closest('[data-bk-add]');
    if (add && root.contains(add)) addToCart(add);
  });

  // A failed add's message shows under the button clicked (the buy box's or the 3D band's).
  function addToCart(btn) {
    if (adding || !variant || !variant.available) return;
    adding = true;
    var box = btn && btn.closest('.bk-buy__cta, .bk-3d__buy');
    var err = (box && box.querySelector('[data-bk-error]')) || root.querySelector('[data-bk-error]');
    all('[data-bk-error]').forEach(function (el) { setText(el, ''); });
    render();
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: qty() }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); api.go('/cart'); })
      .catch(function () {
        adding = false; render();
        setText(err, 'That did not go through. Please try again.');
      });
  }
  // Back from /cart can restore this page from the back/forward cache with Add to cart still locked.
  window.addEventListener('pageshow', function (e) { if (e.persisted) { adding = false; render(); } });

  /* ---------- The 3D book's swing ---------- */
  // Untouched, a model shows itself: first a quick swing each way with a hand that moves with it (so it reads as
  // something to drag), back to the start, then a slow sway between the spine side (the front cover turned right, the
  // spine in view) and the fore-edge side (the cover and some of the pages), never round to the back. Angles are the
  // camera's turn from the model's start (pd-3d-camera.js sets theta 0; the book's own 30-degree turn toward the
  // fore-edge is baked into the model): -72 shows the spine, +18 the pages. It runs only while half the model is on
  // screen and the tab is visible (pausing keeps its place). The shopper touching, dragging, wheeling or keying the model,
  // or pressing "Turn it", ends it for good and leaves the camera where it is. Reduced motion: the hand shows, still, for
  // four seconds and nothing moves.
  var SWING = { spine: -72, pages: 18, introMs: 1800, introDeg: 24, gapMs: 600, halfMs: 7000, easeMs: 2500, handPx: 26 };
  function swing(mv, hand, alsoStop) {
    if (!mv || mv.hasAttribute('data-bk-swing')) return;
    mv.setAttribute('data-bk-swing', '');
    var stopped = false, visible = false, raf = 0, clock = 0, last = 0, still = reducedMotion();
    var mid = (SWING.spine + SWING.pages) / 2, amp = (SWING.pages - SWING.spine) / 2;
    var w = Math.PI / SWING.halfMs, phase = Math.PI - Math.asin(Math.max(-1, Math.min(1, -mid / amp)));   // 0 at the start, heading for the spine
    function showHand(on) { if (hand) hand.classList.toggle('is-on', on); }
    function stop() {
      if (stopped) return;
      stopped = true;
      cancelAnimationFrame(raf);
      showHand(false);
    }
    ['pointerdown', 'wheel', 'keydown', 'touchstart'].forEach(function (t) { mv.addEventListener(t, stop, { passive: true }); });
    if (alsoStop) alsoStop.addEventListener('click', stop);
    mv.addEventListener('camera-change', function (e) { if (e.detail && e.detail.source === 'user-interaction') stop(); });
    function aim(theta) {
      var o = mv.getCameraOrbit && mv.getCameraOrbit();
      if (!o) return;
      mv.cameraOrbit = theta.toFixed(2) + 'deg ' + o.phi + 'rad ' + o.radius + 'm';
      if (mv.jumpCameraToGoal) mv.jumpCameraToGoal();
    }
    function tick(now) {
      raf = 0;
      if (stopped) return;
      if (last) clock += Math.min(64, now - last);
      last = now;
      var t = clock, theta;
      if (t < SWING.introMs) {
        var p = (1 - Math.cos(Math.PI * t / SWING.introMs)) / 2;            // eased 0..1
        theta = -SWING.introDeg * Math.sin(2 * Math.PI * p);                 // to the spine side, the pages side, home
        showHand(true);
        if (hand) hand.style.setProperty('--bk-swipe-x', (-theta / SWING.introDeg * SWING.handPx).toFixed(1) + 'px');
      } else {
        showHand(false);
        var u = t - SWING.introMs - SWING.gapMs;
        if (u <= 0) theta = 0;
        else {
          var k = Math.min(1, u / SWING.easeMs), ease = k * k * (3 - 2 * k);   // the sway fades in from the start
          theta = ease * (mid + amp * Math.sin(w * u + phase));
        }
      }
      aim(theta);
      raf = requestAnimationFrame(tick);
    }
    function update() {
      if (stopped) return;
      var go = visible && !document.hidden && mv.loaded;
      if (still) {
        if (go && !mv.hasAttribute('data-bk-swing-shown')) {
          mv.setAttribute('data-bk-swing-shown', '');
          showHand(true);
          setTimeout(function () { showHand(false); }, 4000);
        }
        return;
      }
      if (go && !raf) { last = 0; raf = requestAnimationFrame(tick); }
      else if (!go && raf) { cancelAnimationFrame(raf); raf = 0; }
    }
    mv.addEventListener('load', function () { setTimeout(update, 120); });   // after pd-3d-camera.js frames it
    document.addEventListener('visibilitychange', update);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].intersectionRatio >= 0.5; update(); }, { threshold: [0, 0.5, 1] }).observe(mv);
    } else { visible = true; update(); }
  }
  (function () {
    var slide = track && track.querySelector('[data-bk-model-slide]');
    if (slide) swing(slide.querySelector('[data-bk-model]'), slide.querySelector('[data-bk-swipe]'), slide.querySelector('[data-bk-model-turn]'));
    var stage = root.querySelector('.bk-3d__stage');
    if (stage) swing(stage.querySelector('[data-bk-3d]'), stage.querySelector('[data-bk-swipe]'));
  })();

  /* ---------- In 3D (wall art's band) ---------- */
  (function () {
    var band = root.querySelector('[data-bk-3d-band]');
    if (!band) return;
    var mv = band.querySelector('[data-bk-3d]'), arWrap = band.querySelector('[data-bk-ar-wrap]'), arBtn = band.querySelector('[data-bk-ar]');
    // model-viewer comes in as the band approaches (or at once without IntersectionObserver).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { loadModelViewer(); io.disconnect(); } }, { rootMargin: '600px 0px' });
      io.observe(band);
    } else loadModelViewer();
    all('a[href="#in-3d"]').forEach(function (a) { ['pointerenter', 'focus', 'touchstart'].forEach(function (t) { a.addEventListener(t, loadModelViewer, { passive: true }); }); });
    // The AR button shows only where model-viewer can open AR (it decides a moment after load).
    // AR shows the book lying flat on the table, the 3D views standing: the OS puts a flat copy in Shopify Files (its
    // URLs in the manifest pd-ar-<product id>.json, kind "book"), read here as the band approaches, so it is in hand
    // before the tap (Quick Look opens only from the tap itself). iPhone: the flat USDZ becomes model-viewer's ios-src.
    // Android: Scene Viewer opened directly on the flat GLB, true size. No manifest (a book not yet rebuilt), or a tap
    // before it has arrived: model-viewer's own AR with the standing model, as before.
    var flat = null;
    function loadFlat() {
      var id = band.getAttribute('data-bk-product-id');
      if (!id || !window.fetch || loadFlat.done) return;
      loadFlat.done = true;
      // Hourly cache key, as wall art's manifest (pd-3d-variants.js): the name never changes.
      fetch('/cdn/shop/files/pd-ar-' + id + '.json?v=' + Math.floor(Date.now() / 3600000), { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (m) {
          if (!m || m.kind !== 'book' || !m.ar || !m.ar.usdz || !m.ar.glb) return;
          flat = m.ar;
          if (mv) mv.setAttribute('ios-src', flat.usdz);
        })
        .catch(function () { /* the standing model's AR stays */ });
    }
    var android = /android/i.test(navigator.userAgent);
    function sceneViewer(glb) {
      var page = location.href.split('#')[0];
      var q = 'file=' + encodeURIComponent(glb) + '&mode=ar_preferred&resizable=false&title=' +
        encodeURIComponent(document.title.split(' – ')[0]) + '&link=' + encodeURIComponent(page);
      location.href = 'intent://arvr.google.com/scene-viewer/1.0?' + q + '#Intent;scheme=https;' +
        'package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;' +
        'S.browser_fallback_url=' + encodeURIComponent(page + '#in-3d') + ';end;';
    }
    if ('IntersectionObserver' in window) {
      var fio = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { loadFlat(); fio.disconnect(); } }, { rootMargin: '600px 0px' });
      fio.observe(band);
    } else loadFlat();
    if (mv && arWrap && arBtn) {
      var check = function () { arWrap.hidden = !mv.canActivateAR; };
      mv.addEventListener('load', function () { check(); setTimeout(check, 1200); });
      arBtn.addEventListener('click', function () {
        if (flat && android) { sceneViewer(flat.glb); return; }
        if (mv.activateAR) mv.activateAR();
      });
    }
    // Desktop: a QR code to this page (wall art's: wa-qrcode.js loads when the card comes within 400px, fine pointers
    // only; the card is hidden on touch screens, and a hidden card never intersects).
    var qr = band.querySelector('[data-bk-qr]');
    if (!qr) return;
    var drawn = false, loading = false;
    function draw() {
      if (drawn || !window.qrcode) return false;
      var q = window.qrcode(0, 'M'); q.addData(location.origin + location.pathname + '#in-3d'); q.make();
      qr.innerHTML = q.createSvgTag({ cellSize: 3, scalable: true });
      drawn = true;
      return true;
    }
    function qrLoad() {
      if (draw() || loading) return;
      var src = qr.getAttribute('data-bk-qr-src');
      if (!src) return;
      loading = true;
      var sc = document.createElement('script');
      sc.src = src; sc.async = true; sc.onload = draw;
      sc.onerror = function () { loading = false; };
      document.head.appendChild(sc);
    }
    if ('IntersectionObserver' in window) {
      var qio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) qrLoad(); });
        if (drawn) qio.disconnect();
      }, { rootMargin: '400px 0px' });
      qio.observe(qr.closest('.bk-qr-card') || qr);
    }
  })();

  // Sections fade up as they enter (wall art's; CSS turns it off under reduced motion). They are hidden only once this
  // script is running (.bk-reveal-on), so a page whose script fails still shows them.
  if ('IntersectionObserver' in window) {
    root.classList.add('bk-reveal-on');
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    all('[data-bk-reveal]').forEach(function (el) { rio.observe(el); });
  } else all('[data-bk-reveal]').forEach(function (el) { el.classList.add('is-in'); });

  /* ---------- Bundle and save ---------- */
  // The band and its button show once Selleasy's bought-together widget is up in the mount (wall art's two ways in: the
  // initialized event, or a real widget row appearing), so a book with no bundle shows neither.
  var bundle = root.querySelector('[data-bk-bundle]'), bundleLink = root.querySelector('[data-bk-bundle-link]');
  var mount = bundle && bundle.querySelector('.Logbase-bought_together');
  var ROW = '.ppcse-card-product, .ppcse, .ppcse-m, .lb-upsell-money';
  function showBundle() {
    if (bundle) bundle.classList.add('is-ready');
    if (bundleLink) bundleLink.hidden = false;
  }
  window.addEventListener('lb-upsell-widget-event', function (e) {
    var d = e.detail || {};
    if (d.widgetType === 'product-page-cross-sell-embedded-widget' && d.status === 'initialized') showBundle();
  });
  if (mount) {
    if (mount.querySelector(ROW)) showBundle();
    else if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { if (mount.querySelector(ROW)) { showBundle(); mo.disconnect(); } });
      mo.observe(mount, { childList: true, subtree: true });
    }
  }

  /* ---------- Contact: the chat item shows once the store's chat (chat-widget.js) is up ---------- */
  var chatItem = root.querySelector('[data-bk-chat]');
  function chatReady() { if (chatItem && window.PedimentChat && window.PedimentChat.open) chatItem.hidden = false; }
  chatReady();
  window.addEventListener('pediment-chat:ready', chatReady);
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bk-chat-open]');
    if (!a || !window.PedimentChat || !window.PedimentChat.open) return;
    e.preventDefault();
    window.PedimentChat.open();
  });

  /* ---------- In-page links (wall art's): a quick scroll, then focus moves to the target ---------- */
  var DURATION = 350, scrollRun = 0;
  function jumpTo(y) { try { window.scrollTo({ top: y, left: window.scrollX, behavior: 'instant' }); } catch (e) { window.scrollTo(window.scrollX, y); } }
  function targetTop(el) {
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var margin = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
    return Math.max(0, Math.min(max, Math.round(el.getBoundingClientRect().top + window.scrollY - margin)));
  }
  function focusTarget(el) {
    if (!el.matches('a[href], button, input, select, textarea, summary, [tabindex]')) el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function scrollToTarget(el) {
    var run = ++scrollRun;
    if (reducedMotion()) { jumpTo(targetTop(el)); focusTarget(el); return; }
    var from = window.scrollY, start = null;
    function step(now) {
      if (run !== scrollRun) return;
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / DURATION), eased = 1 - Math.pow(1 - t, 3);
      jumpTo(from + (targetTop(el) - from) * eased);
      if (t < 1) requestAnimationFrame(step); else focusTarget(el);
    }
    requestAnimationFrame(step);
  }
  ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
    window.addEventListener(type, function () { scrollRun++; }, { passive: true });
  });
  function setHash(id) {
    var hash = '#' + encodeURIComponent(id), u = location.pathname + location.search + hash;
    var method = location.hash === hash ? 'replaceState' : 'pushState';
    try { History.prototype[method].call(history, history.state, '', u); } catch (e) { /* no history API */ }
  }
  root.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || !root.contains(a) || a.closest('.jdgm-widget, .Logbase-bought_together')) return;
    var id = decodeURIComponent(a.getAttribute('href').slice(1));
    var el = id && (document.getElementById(id) || document.getElementsByName(id)[0]);
    if (!el) return;
    e.preventDefault();
    setHash(id);
    scrollToTarget(el);
  });

  api.state = function () { return { variantId: variant && variant.id, tier: state.tier, quantity: qty(), slide: idx, price: price }; };
  // For a page that renders this contract with a 3D book of its own (a product lander's hero): the one model-viewer
  // import, and the swing. Nothing here calls them.
  api.loadModelViewer = loadModelViewer;
  api.swing = swing;
  render();
})();
